import { radiusCva } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, type MouseEventHandler, use, useCallback } from "react"

import { genericMemo } from "../../../utils/optimization"
import { type IMentionListContext, MentionListContext } from "./context"
import { menuItem } from "./cva"

interface MentionListItemProps<TItem> extends ComponentPropsWithRef<"li"> {
	item: TItem
}

export const MentionListItem = genericMemo(function <TItem>(props: MentionListItemProps<TItem>) {
	const { children, className, ref, item, onClick, ...rest } = props

	const { selectItem, isActive, variant, size, radius } = use(MentionListContext) as IMentionListContext<TItem>

	const handleClick = useCallback<MouseEventHandler<HTMLLIElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			selectItem(item)
		},
		[item, onClick, selectItem],
	)

	return (
		<li
			ref={ref}
			className={cx(menuItem({ size, variant }), radiusCva({ radius, maxLarge: true }), className)}
			onClick={handleClick}
			data-active={isActive(item) ? "" : undefined}
			{...rest}
		>
			{children}
		</li>
	)
})
